// extracted by mini-css-extract-plugin
export default {"topNavigation":"bMblW","container":"_1BRQe","categoriesContainer":"_3Ci8m","link":"_2MzDA"};